// Nickname persistence — set once, reuse across sessions until the player
// changes it. Stored in localStorage under a stable key. Centralized here so
// the storage shape is consistent across Home, lobby, and any future UI that
// surfaces or edits the saved nick.

import { storageGet, storageRemove, storageSet } from './safeStorage.js';

const KEY = 'mafia.name';
const MAX_LEN = 20;

// Collapse runs of whitespace into single spaces, trim, and cap length. The
// server caps at 24; the client picks a slightly stricter 20 so the input
// field never overflows visually. We don't strip control chars by character
// class — keeping the regex simple and conservative.
export function sanitizeNickname(raw: string): string {
  return raw.replace(/\s+/g, ' ').trim().slice(0, MAX_LEN);
}

export function loadNickname(): string | null {
  const raw = storageGet(KEY);
  if (!raw) return null;
  return sanitizeNickname(raw) || null;
}

export function saveNickname(name: string): void {
  const sane = sanitizeNickname(name);
  if (!sane) return;
  // Storage failure (private browsing etc.) silently degrades — worst case
  // the user retypes their nick next session.
  storageSet(KEY, sane);
}

export function clearNickname(): void {
  storageRemove(KEY);
}
